export class BaseStore {
  constructor(root) {
    this._root = root;
  }

  get stores() {
    return this._root;
  }
}



// WEBPACK FOOTER //
// ./src/stores/base.js